import { useMemo } from 'react';
import uniqBy from 'lodash/uniqBy';
import { useRouter } from 'next/router';
import { useGet as useGetHcdSpecialities } from '@maiia/model/generated/model/api-patient/hooks/patPublicHcdSpecialities';
import {
  ResultPageSpecialityHcd,
  SpecialityHcd,
} from '@maiia/model/generated/model/api-patient/api-patient';

type RequiredSpecialityHcd = Required<SpecialityHcd>;
type ResultPageGetHcdSpecialities = ResultPageSpecialityHcd & {
  items?: RequiredSpecialityHcd[];
};

const defaultSpecialities = [
  {
    name: 'Médecin généraliste',
    shortName: 'medecin-generaliste',
  },
  {
    name: 'Psychiatre',
    shortName: 'psychiatre',
  },
  {
    name: 'Pédiatre',
    shortName: 'pediatre',
  },
];

const defaultSpeciality = defaultSpecialities[0];

const useTLCSpecialities = () => {
  const { data: tlcSpecialities } = useGetHcdSpecialities<
    unknown,
    ResultPageGetHcdSpecialities
  >({
    limit: 200,
    page: 0,
  });
  const list = useMemo(
    () =>
      uniqBy(
        [...(tlcSpecialities?.items ?? []), ...defaultSpecialities],
        'shortName',
      )
        .map(({ shortName, name }) => ({
          label: name,
          value: shortName,
        }))
        .sort((a, b) => a.label.localeCompare(b.label)),
    [tlcSpecialities],
  );

  const {
    query: { slug },
  } = useRouter();
  let specialityShortName = defaultSpeciality.shortName;
  if (slug && slug[0] !== 'specialities') {
    [specialityShortName] = slug as string[];
  }

  const currentSpeciality = list.find(s => s.value === specialityShortName) || {
    label: defaultSpeciality.name,
    value: defaultSpeciality.shortName,
  };

  return { list, currentSpeciality };
};

export default useTLCSpecialities;
